import { jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { MenuButton } from "@reach/menu-button";
import { dropdownMenuContext } from "./dropdown-menu-context.es.js";
const propTypes = {
  as: PropTypes.elementType,
  disabled: PropTypes.bool
};
const defaultProps = {
  as: "button",
  disabled: false
};
const DropdownMenuButton = forwardRef(({ as, ...restProps }, forwardedRef) => {
  const { buttonRef } = useContext(dropdownMenuContext);
  useImperativeHandle(forwardedRef, () => buttonRef.current);
  return /* @__PURE__ */ jsx(MenuButton, { as, ref: buttonRef, ...restProps });
});
DropdownMenuButton.propTypes = propTypes;
DropdownMenuButton.defaultProps = defaultProps;
export {
  DropdownMenuButton
};
